import { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

export function useSyncBotSelection() {
  const { botId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleBotChange = (e) => {
      const newBotId = e?.detail;
      
      if (newBotId !== undefined && newBotId !== null) {
        const botIdString = String(newBotId);
        const currentBotIdString = String(botId);
        
        console.log(`[useSyncBotSelection] Novo bot: ${botIdString}, Atual: ${currentBotIdString}`);
        
        if (botIdString !== currentBotIdString) {
          // ✅ Substitui apenas o último segmento numérico (o botId)
          const currentPath = location.pathname;
          const newPath = currentPath.replace(/\/\d+$/, `/${botIdString}`);
          
          console.log(`[useSyncBotSelection] Redirecionando: ${currentPath} → ${newPath}`);
          navigate(newPath);
        }
      }
    };

    window.addEventListener('selectedBotChanged', handleBotChange);
    return () => window.removeEventListener('selectedBotChanged', handleBotChange);
  }, [botId, navigate, location.pathname]);
}